import { SelectOption } from 'components/Selects/Select/StepsDropdown/types';
import { PurposeOptions } from 'hausbank/inquiry/fields';
import { translations } from 'new/form/common/types';
import { FormatMessage } from 'utils/intl';

const { facade, balcony, window, undergroundGarage, roof, heating, line, other } =
  translations.inquiryType.hausbank.pages.financingNeed.sections.purpose.fields.purposeKind.options;

export const purposeKindOptions: SelectOption<PurposeOptions>[] = [
  {
    label: facade,
    value: PurposeOptions.facade,
  },
  {
    label: balcony,
    value: PurposeOptions.balcony,
  },
  {
    label: window,
    value: PurposeOptions.window,
  },
  {
    label: undergroundGarage,
    value: PurposeOptions.underground_garage,
  },
  {
    label: roof,
    value: PurposeOptions.roof,
  },
  {
    label: heating,
    value: PurposeOptions.heating,
  },
  {
    label: line,
    value: PurposeOptions.line,
  },
  {
    label: other,
    value: PurposeOptions.other,
  },
];

export const getHausbankPurposeKindOptions = (
  formatMessage: FormatMessage,
): SelectOption<PurposeOptions>[] => {
  return purposeKindOptions.map(({ label, value }) => {
    return {
      value,
      label: formatMessage({ id: label }),
    };
  });
};
